import AreaOfStudyReducer from './AreaOfStudyReducer';
export default AreaOfStudyReducer;
